import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthPelvicFloorCoContraction extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 'absent', value: 'absent' },
            { id: 'present', value: 'present' }
        ];

        return (
            <div>
            <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Co-contraction'/>
                        <label className={styles.textarea_label}>Pelvic Floor Co-contraction</label>
                        <div className={styles.pelv}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='STNO'
                                entityKeyValue={this.props.stno}
                                field='STPELVICFLOORCOCONTRACTION'
                                className={styles.pelv_ddl}
                                customOptions={dropdownOptions}
                            />
                          </div>
                        <span className={styles.prev_comments_wrapper}>
                            {this.props.prevVal}
                        </span>
                    </div>

                </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevVal = '';
    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevVal = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORCOCONTRACTION'];
    }

    return {
        noteId,
        stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORCOCONTRACTION !== null,
        prevVal,
    };
}

const connectedStrengthPelvicFloorCoContraction = connect(mapStateToProps)(StrengthPelvicFloorCoContraction);
export { connectedStrengthPelvicFloorCoContraction as StrengthPelvicFloorCoContraction };


